define('Model', [
	'inherit',
	'logger',
	'request',
	'Promise',
	'Emitter',
	'Model.List',
	'config'
], function (
	/** function */inherit,
	/** logger */logger,
	/** request */request,
	/** Promise */Promise,
	/** Emitter */Emitter,
	/** Model.List */List,
	/** config */config
) {
	"use strict";

	var Event = Emitter.Event;
	var _toString = {}.toString;
	var _stringifyJSON = JSON.stringify;
	var _type = function (val) {
		return val === null ? 'null' : _toString.call(val).toLowerCase().slice(8, -1);
	};


	/**
	 * Локальный идентификтор модели
	 * @type {number}
	 */
	var cid = 1;


	/**
	 * Быстрое клонирование
	 * @param   {*}  obj
	 * @param   {boolean} [isObject]
	 * @returns {*}
	 * @private
	 */
	function _clone(obj, isObject) {
		var i, key,
			res = obj;

		if (isObject !== true && obj instanceof Array) {
			i = obj.length;
			res = [];
			while (i--) {
				res[i] = _clone(obj[i]);
			}
		} else if (isObject === true || obj instanceof Object) {
			if (obj.toJSON !== void 0) {
				res = obj.toJSON();
			} else {
				res = {};
				for (key in obj) {
					res[key] = _clone(obj[key]);
				}
			}
		}

		return res;
	}

	// Установкаизначальных аттрибутов
	var _setInitialAttr = function (model, defaults, target, absKey, localKey, value) {
		if (model.scheme[absKey] === 'set') {
			target[localKey] = _clone(defaults, true);

			for (var key in value) {
				_setInitialAttr(
					model,
					defaults[localKey],
					target[localKey],
					absKey + '.' + localKey,
					key,
					value[key]
				);
			}
		} else if (model.nested.hasOwnProperty(absKey)) {
			target[localKey] = new model.nested[absKey](value);
		} else {
			target[localKey] = value;
		}
	};

	// Установка аттрибутов согласно схеме
	var _setAttr = function (model, absKey, attr, newValue, changed, changes) {
		var idx = absKey.lastIndexOf('.'),
			attributes = model.attributes,
			_attributes = model._attributes,
			value = attributes[attr];

		if (idx !== -1) {
			attr = absKey.substr(idx + 1);
			value = model.get(absKey);
		}

		if (model.nested[absKey] !== void 0) {
			// Обновление вложенной модели или списка
			model.get(absKey).set(newValue, {reset: true});
		}
		else if (model.scheme[absKey] === 'set') {
			for (var key in newValue) {
				_setAttr(model, absKey + '.' + key, key, newValue[key], changed, changes);
			}
		}
		else if (_notEqual(value, newValue)) {
			if (absKey !== attr) {
				var chain = absKey.split('.'),
					length = chain.length,
					i = 0,
					n = length - 1,
					part,
					dottedKey;

				for (; i < n; i++) {
					part = chain[i];

					if (attributes[part] === void 0) {
						attributes[part] = {};
					}

					if (_attributes[part] === void 0) {
						_attributes[part] = {};
					}

					if (changed[part] === void 0) {
						changed[part] = {};
					}

					attributes = attributes[part];
					_attributes = _attributes[part];
					changed = changed[part];

					if (attributes.set !== void 0) {
						// Модель или Список
						attributes.set(chain.slice(i + 1).join('.'), newValue, {reset: true});
						return;
					}

					dottedKey = dottedKey === void 0 ? part : dottedKey + '.' + part;

					if (changes.byKey[dottedKey] === void 0) {
						changes.byKey[dottedKey] = attributes;
						changes.push(dottedKey);
					}
				}
			}

			_attributes[attr] = value;
			changed[attr] = newValue;
			attributes[attr] = newValue;

			changes.push(absKey);
			changes.byKey[absKey] = newValue;
		}
	};

	function _setNestedChanges(/** Array */nestendChanges, /** Array */changes, /** Object */changed) {
		var i = nestendChanges.length;

		while (i--) {
			var item = nestendChanges[i];
			var attr = item.attr;

			changes.push(attr);
			changes.byKey[attr] = item.changes;

			if (attr.indexOf('.') > -1) {
				var chain = attr.split('.');
				var endIdx = chain.length - 1;
				var _changed = changed;

				for (var c = 0; c < endIdx; c++) {
					if (_changed[chain[c]] === void 0) {
						_changed = _changed[chain[c]] = {};
					} else {
						_changed = _changed[chain[c]];
					}
				}

				_changed[chain[endIdx]] = item.changed;
			} else {
				changed[attr] = item.changed;
			}

			var innerChanges = item.changes;
			for (var j = 0, jn = innerChanges.length; j < jn; j++) {
				var innerAttr = attr + '.' + innerChanges[j];
				changes.push(innerAttr);
				changes.byKey[innerAttr] = innerChanges.byKey[innerChanges[j]];
			}
		}
	}

	/**
	 * Быстрое сравнение двух переменных
	 * @param   {*}  actual
	 * @param   {*}  expected
	 * @returns {boolean}
	 * @private
	 */
	function _notEqual(actual, expected) {
		if (actual === expected) {
			return false;
		}

		var expectedType = typeof expected;

		if (expectedType === 'string' || expectedType === 'number' || expectedType === 'boolean') {
			return actual != expected;
		}

		// А теперь детально расмотрим
		var idx, actualType = typeof actual;

		/* istanbul ignore else */
		if (actualType === expectedType) {
			if (actual === null) {
				return true;
			}

			/* istanbul ignore else */
			if (expected instanceof Array) {
				idx = expected.length;

				if (actual.length !== idx) {
					return true;
				}

				while (idx--) {
					if (_notEqual(actual[idx], expected[idx])) {
						return true;
					}
				}
			}
			else if (expected instanceof Object) {
				var key,
					keys = Object.keys(expected)
				;

				idx = keys.length;

				if (Object.keys(actual).length !== idx) {
					return true;
				}

				while (idx--) {
					key = keys[idx];

					if (_notEqual(actual[key], expected[key])) {
						return true;
					}
				}
			}

			return false;
		}

		return true;
	}


	/**
	 * Создаеть геттер для атрибутов
	 * @param   {string}   attrs    название своства
	 * @param   {boolean}  retBool  вернуть булево значение
	 * @returns {Function}
	 * @private
	 */
	function _createGetter(attrs, retBool) {
		var code = (function (name) {
			var attributes = this.$,
				scheme = this.scheme,
				nested = this.nested,
				retVal = attributes[name = (this.shortcuts[name] || name)],
				key,
				length
			;

			/* istanbul ignore else */
			if (retVal === void 0 && name.indexOf('.') !== -1) {
				name = name.split('.');
				key = name[0];
				length = name.length;

				if (nested[key] !== void 0) {
					// Вложенная модель
					retVal = attributes[key];

					if (scheme[key] === 'model.list') {
						retVal = length === 2
								? retVal[name[1]]
								: retVal[name[1]].get(name.slice(2).join('.'));
					} else {
						retVal = retVal.get(length === 2 ? name[1] : name.slice(1).join('.'));
					}
				}
				else if (length === 2) {
					retVal = attributes[key] && attributes[key][name[1]];
				}
				else {
					for (var i = 0, n = length - 1; i < n; i++) {
						key = name[i];
						attributes = attributes[key];

						/* jshint eqnull:true */
						if (attributes == null) {
							return;
						} else if (attributes.get !== void 0) {
							if (attributes.Model !== void 0) {
								retVal = attributes[name[i + 1]];

								if (i + 2 <= n) {
									retVal = retVal.get(name.slice(i + 2).join('.'));
								}

								return retVal;
							}
							else {
								return attributes.get(name.slice(i + 1).join('.'));
							}
						}
					}

					retVal = attributes[name[n]];
				}
			}

			return retVal;
		}).toString();

		if (retBool) {
			code = code
				.replace(/(return)\s+(.+,\s*)?(\w+)/g, function (_, ret, incut, retVal) {
					return ret + ' ' + (incut || '') + '!!' + retVal;
				})
				.replace(/(return)(.*?)(;|})/, function (_, ret, incut, end) {
					/* istanbul ignore next */
					return ret + (incut ? incut + ',' : '') + ' false' + end;
				})
			;
		}

		/* jshint evil:true */
		return Function('return ' + code.replace('this.$', 'this.' + attrs))();
	}


	function _emitChangeEvents(/** string */type, /** Model */model, /** Array */changes, /** Object */changed) {
		var i = changes.length;
		var evt = new Event(type); // для «скорости» используем единый объект

		evt.target = model;
		evt.changes = changes;
		evt.allChanged = changed;

		while (i--) {
			var attr = changes[i];

			evt.attr = attr;
			evt.type = type + ':' + attr;
			evt.changed = changes.byKey[attr];

			model.emit(evt.type, [evt, model]);
		}

		evt.type = type;
		evt.attr = void 0;
		evt.changed = changed;

		model.emit(evt.type, [evt, model]);
	}


	/**
	 * Модель
	 * @class Model
	 * @constructs Model
	 * @mixes Emitter
	 * @param  {Object}  [attrs]  свойства
	 */
	function Model(attrs) {
		var key,
			valueValidator = this.valueValidator,
			value,
			attributes = this.attributes = {},
			defaults = this.defaults
		;


		this.cid = 'c' + cid++;
		this.changed = {}; // Если это не сделать, будет работать с общим объектом в прототипе
		this._attributes = {};


		// Устанавливаем свойства модели
		/* istanbul ignore else */
		if (attrs) {
			for (key in attrs) {
				value = attrs[key];

				/* istanbul ignore else */
				if (valueValidator !== null) {
					value = valueValidator(value, key, attrs, this);
				}

				_setInitialAttr(this, defaults[key], attributes, key, key, value);
			}
		}


		// Заполняем свойствами по умолчанию
		for (key in defaults) {
			/* istanbul ignore else */
			if (!attributes.hasOwnProperty(key)) {
				value = defaults[key];

				/* jshint eqnull:true */
				/* istanbul ignore else */
				if ((value !== null) && (typeof value === 'object')) {
					value = _clone(value);
				}

				attributes[key] = value;
			}
		}


		// Идетификатор модели
		/* istanbul ignore else */
		if (attributes[this.idAttr] !== void 0) {
			this.id = attributes[this.idAttr];
		}

		// Активация вложенных моделей
		if (this._activateNested !== void 0) {
			this._activateNested(attributes);
		}

		// Обновление геттеров
		if (this._updateGetters !== void 0) {
			this._updateGetters(attributes, attributes);
		}
	}


	Model.fn = Model.prototype = /** @lends Model# */{
		constructor: Model,

		/**
		 * Название класса
		 * @type {string}
		 */
		className: 'Model',


		/**
		 * Локальный идентификатор модели
		 * @type  {string}
		 */
		cid: null,

		/**
		 * Идентификатор модели (PK)
		 * @type {*}
		 */
		id: null,


		/**
		 * Имя свойства-идентификатора (PK)
		 * @type {string}
		 */
		idAttr: 'id',


		/**
		 * Индекс вложенных моделей/списков
		 * @type {Object}
		 * @private
		 */
		nested: {},


		/**
		 * Схема модели (создается на основе `defaults` при `extend`)
		 * @type {Object}
		 * @private
		 */
		scheme: {},


		/**
		 * Свойства по умолчанию
		 * @type {Object}
		 */
		defaults: {},


		/**
		 * Массив обязательных свойств от сервер, если их не будет, то запонить из `defaults`
		 * @type {string[]}
		 */
		required: [],


		/**
		 * Доступ к свойствам через гетеры, либо определить объект "геттер" => "свойство"
		 * @type {boolean|Object}
		 */
		getters: false,


		/**
		 * Тригеры на add/update/save/remove, а так же beforeadd и т.д.
		 * @type {Object}
		 */
		triggers: {},


		/**
		 * Валидатор значения аттрибута
		 * @type {Function|null}
		 */
		valueValidator: null,


		/**
		 * Список измененнных ствойств их новых значений
		 * @type {Object}
		 */
		changed: {},


		/**
		 * Список измененнных ствойств их старых значений
		 * @type {Object}
		 * @private
		 */
		_attributes: {},


		/**
		 * Короткий доступ к свойствам
		 * @type {Object}
		 */
		shortcuts: {},


		/**
		 * Объект отвечающий за запросы к серверу
		 * @type {request}
		 */
		request: request,


		/**
		 * Объект отвечающий за хранение данных (кеш)
		 * @type {Storage}
		 */
		storage: null,


		/**
		 * URL получения/сохранения/удаления модели
		 * @type {string}
		 */
		url: "",


		/**
		 * URL получения списка моделей (коллекции)
		 * @type {string}
		 */
		findUrl: "",


		/**
		 * URL получения одной модели
		 * @type {string}
		 */
		findOneUrl: "",


		/**
		 * URL создания модели
		 * @type {string}
		 */
		addUrl: "",


		/**
		 * URL сохранения модели
		 * @type {string}
		 */
		saveUrl: "",


		/**
		 * URL удаления
		 * @type {string}
		 */
		removeUrl: "",

		/**
		 * Идут изменения модели (set)
		 * @type {boolean}
		 * @private
		 */
		_changing: false,


		/**
		 * Проверить значение свойства на истинность
		 * @param   {string}  name
		 * @returns {boolean}
		 * @method Model#is
		 */
		is: _createGetter('attributes', true),


		/**
		 * Получить значение свойства
		 * @param   {string}  name
		 * @returns {*}
		 * @method Model#get
		 */
		get: _createGetter('attributes'),


		/**
		 * Получить предыдущие значение свойства
		 * @param   {string}  name
		 * @returns {*}
		 * @method Model#previous
		 */
		previous: _createGetter('_attributes'),


		/**
		 * Вызвать тригер
		 * @param  {String} name
		 * @param  {*} [args]
		 * @private
		 */
		_callTrigger: function (name, args) {
			var trigger = this.triggers[name];
			trigger && trigger.call(this, args);
		},


		/**
		 * Обработка события вожженых моделей
		 * todo: Нужно доработать события для всей цепочки
		 * @param {string} attr
		 * @param {Object} evt
		 * @private
		 */
		_nestedHandleEvent: function (attr, evt) {
			var type = evt.type;
			var evtChanged = evt.changed || evt.target;
			var evtChanges = evt.changes;

			if (type === 'update') {
				type = 'change';
			}

			if (evtChanges === void 0) {
				evtChanges = [attr];
				evtChanges.byKey = {};
				evtChanges.byKey[attr] = evtChanged;
			}

			if (this._changing && type === 'change') {
				if (this._nestedChanges === void 0) {
					this._nestedChanges = [];
				}

				this._nestedChanges.push({
					attr: attr,
					changed: evtChanged,
					changes: evtChanges
				});
			} else if (type === 'add' || type === 'remove') {
				var nextEvt = new Event({
					type: type + ':' + attr,
					attr: attr,
					list: evt.list,
					target: evt.target
				});
				
				this.emit(nextEvt.type, [nextEvt, this]);
			} else {
				var allChanged = {};
				var changes = [];

				changes.byKey = {};
				
				_setNestedChanges([{
					attr: attr,
					changed: evtChanged,
					changes: evtChanges
				}], changes, allChanged);

				_emitChangeEvents(type, this, changes, allChanged);
			}
		},


		/**
		 * Установить свойства или свойство
		 * @param   {string|Object}  attr  название или объект свойств
		 * @param   {*|Object}       [newValue]  значение или опции
		 * @param   {boolean|Object} [options] опции (silent, clean, sync)
		 * @returns {Model}
		 */
		set: function (attr, newValue, options) {
			var attrs,
				changes = [],
				silent, // не испускать событий при изменении
				sync, // режим синхронизации (напрмиер надо проверить required)
				changed = this.changed,
				valueValidator = this.valueValidator
			;

			changes.byKey = {};
			this._changing = true;

			// Получем свойства
			if (typeof attr === 'object') {
				attrs = attr;
				options = options || newValue;
			} else {
				(attrs = {})[attr] = newValue;
			}


			// Опции
			if (options instanceof Object) {
				sync = options.sync;
				silent = options.silent;

				if (options.clean) {
					// установить свойства и не оставить следа об этих изменениях
					changed = {};
				}
			}
			else {
				silent = (options === true);
			}


			// Назначаем идентификатор (PK), если его передали
			/* istanbul ignore else */
			if (attrs[this.idAttr] !== void 0) {
				this.id = attrs[this.idAttr];
			}

			if (sync) {
				this._setRequired && this._setRequired(attrs);
			}

			// Перебераем и изменяем свойства
			for (attr in attrs) {
				newValue = attrs[attr]; // Новое значение
				attr = (this.shortcuts[attr] || attr);

				/* istanbul ignore else */
				if (valueValidator !== null) {
					newValue = valueValidator(newValue, attr, attrs, this);
				}

				_setAttr(this, attr, attr, newValue, changed, changes);
			}

			if (this._nestedChanges !== void 0) {
				_setNestedChanges(this._nestedChanges, changes, changed);
			}

			if ((this._updateGetters !== void 0) && (changes.length > 0)) {
				// Обновим геттеры
				this._updateGetters(changed, attrs);
			}

			// Если есть изменения и не «тишина»
			/* istanbul ignore else */
			if ((changes.length > 0) && !silent) {
				_emitChangeEvents('change', this, changes, changed);
			}

			this._changing = false;
			this._nestedChanges = void 0;

			return this;
		},

		
		/**
		 * Увеличить атрибут на `value`
		 * @param   {string}  attr
		 * @param   {number}  [value]
		 * @param   {object}  [options]
		 * @returns {Model}
		 */
		increment: function (attr, value, options) {
			if (arguments.length == 1 || value instanceof Object) {
				options = value;
				value = 1;
			}

			value = parseInt(value, 10);

			return Number.isNaN(value) ? this : this.set(attr, this.get(attr) + value, options);
		},


		/**
		 * Получить объект свойств (клон аттрибутов)
		 * @param   {boolean}  [ref]  вернуть ссылку на аттрибуты
		 * @returns {Object}
		 */
		toJSON: function (ref) {
			var attrs = this.attributes;
			return ref ? attrs : _clone(attrs, true);
		},


		/**
		 * Явялется ли модель «новой»?
		 * @returns {boolean}
		 */
		isNew: function () {
			return this.id === null;
		},


		/**
		 * Очередь действий
		 * @param   {Function}  fn
		 * @returns {Promise}
		 */
		queue: function (fn) {
			var meta = logger.meta(-2),
				model = this,
				call = function () {
					/* istanbul ignore else */
					if (model.removed) {
						// @todo: Безумно спорное место, как и весь `removed`
						var err = new Error('MODEL_REMOVED');
						err.model = model;
						return Promise.reject(err);
					}

					return fn(model, meta);
				}
			;

			if (!this._queue) {
				this._queue = new Promise(function (resolve) { resolve(); });
				//this._queue.__logger__.meta = meta;
			}


			this._queue = this._queue.then(call, call);
			//this._queue.__logger__.meta = meta;

			return this._queue;
		},


		/**
		 * Вызывается при findOne, если вернуть `false` будет отправлен запрос на серевер
		 * @returns {boolean}
		 * @protected
		 */
		isDataFully: function () {
			return true;
		},


		/**
		 * Изменена ли модель?
		 * @param   {string}  [name]
		 * @returns {boolean}
		 */
		hasChanged: function (name) {
			/* istanbul ignore else */
			if (name) {
				return this.changed[name];
			}

			for (var key in this.changed) {
				/* istanbul ignore else */
				if (this.changed.hasOwnProperty(key)) {
					return true;
				}
			}

			return this.isNew();
		},


		/**
		 * Обновить информацию о модели
		 * @param   {Object}  [params]  доп. параметры
		 * @returns {Promise}
		 */
		fetch: function (params) {
			params = params || {};
			params[this.idAttr] = this.id;
			return this.constructor.findOne(params);
		},


		/**
		 * Предварительная обработка ответа сервера
		 * @param   {Object}  body  тело ответа
		 * @param   {request.Request} req  объект запроса
		 * @returns {Object}
		 */
		parse: function (body, req) {
			return body;
		},

		/**
		 * Подготовка данных модели перед отправкой на сервер
		 * @param   {String} method метод сохранения add или save
		 * @param   {Object} attrs свойства модели
		 * @returns {Object} свойства модели, подготовленные для передачи в запрос
		 */
		prepareSendData: function (method, attrs) {
			return attrs;
		},

		/**
		 * Сохранить модель
		 * @param   {string|Object}   [attr]    свойство, которое нужно установить перед сохранением
		 * @param   {*}               [value]   значение
		 * @param   {Object|boolean}  [options] опции
		 * @returns {Promise}
		 */
		save: function save(attr, value, options) {
			/* istanbul ignore else */

			if (attr) {
				// Устанавливаем аттрибуты, если переданны (до сохранения)
				this.set(attr, value, options);
			}

			return this.queue(function (/** Model */model, /** LoggerMeta */meta) {
				if (model.hasChanged()) {
					var isNew = model.isNew(),
						attrs = model[isNew ? 'attributes' : 'changed'],
						method = model.addUrl && isNew ? 'add' : 'save',
						url = model.constructor.url(method, model.attributes),
						cacheChanged = model.changed
					;

					model._callTrigger(isNew ? 'beforeadd' : 'beforeupdate', attrs);
					model._callTrigger('beforesave', attrs);

					// Для поддержки saveUrl
					if (!isNew) {
						attrs[model.idAttr] = model.id;
					}

					// Подготавливаем данные
					attrs = model.prepareSendData(method, attrs);

					// Сбрасываем изменения
					model.changed = {};

					// Обновляем данные в хранилище
					model.storage && model.storage.update(model.toJSON());

					// Отправляем запрос
					return model.request.post(
						url,
						attrs,
						{
							logger: model.className + '.save',
							loggerMeta: meta
						}).then(function (req) {
							var body = model.parse(req.body, req);

							body && model.set(body, { clean: true, sync: true });
							model.constructor.all.set([model]);
							model.trigger('sync', model);

							model._callTrigger(isNew ? 'add' : 'update', attrs);
							model._callTrigger('save', attrs);

							return model;
						}).fail(function () {
							// При неудаче возвращаем поля на место
							model.changed = cacheChanged;
						});
				} else {
					return model;
				}
			});
		},


		/**
		 * Удалить модель
		 * @param   {Object}   [query]  дополнительные GET-параметры
		 * @returns {Promise}
		 */
		remove: function remove(query) {
			return this.queue(function (/** Model */model, /** LoggerMeta */meta) {
				query = query || {};
				query[model.idAttr] = model.id;

				query = model.prepareSendData('remove', query);
				model._callTrigger('beforeremove', query);

				return model.request.call(
					model.constructor.url('remove', model),
					query,
					{
						logger: model.className + '.remove',
						loggerMeta: meta,
						type: 'DELETE'
					}).done(function () {
						model.removed = true; // помечаем объект как удаленный
						model.trigger({ type: 'remove', model: model }, model);
						model.destroy();
						model._callTrigger('remove', query);
					});
			});
		},


		/**
		 * Уничтожить модель
		 * @returns {Model}
		 */
		destroy: function () {
			var model = this;

			/* istanbul ignore else */
			if (!model.destroyed) {
				model.destroyed = true;
				
				// Удаляем данные из хранилища
				model.storage && model.storage.remove(model.id);
				model.trigger({type: 'destroy', model: model}, model);

				model.off(); // и отписываем всех слушателей

				/* jshint expr:true */
				(model._deactivateNested !== void 0) && model._deactivateNested(this.attributes);
			}
		},


		/**
		 * Метод для установки или получения мета информации о модели
		 * @param {string|object} [property] имя свойства (с поддержкой точечной нотации) или обьект свойство:значение
		 * @param {*} [value] значение для установки
		 * @returns {*}
		 */
		meta: function (property, value) {
			var _meta = this._meta,
				argsLength = arguments.length;

			if (_meta === void 0 || property === null) {
				this._meta = _meta = config({});
			}

			/* istanbul ignore else */
			if (argsLength === 0) {
				return _meta;
			}
			else if (argsLength === 2) {
				_meta.set(property, value);
			}
			else if (argsLength === 1) {
				if (typeof property === 'object') {
					_meta.set(property);
				} else {
					return _meta.get(property);
				}
			}

			return this;
		},

		/**
		 * Анулировать кеш
		 * @return {Model}
		 */
		expire: function () {
			this.expired = true;
			return this;
		}
	};


	/**
	 * Создание расширенной модели
	 * @memberOf Model
	 * @param   {Object} methods
	 * @returns {Model}
	 */
	Model.extend = function (methods) {
		var ModelExt = inherit(this, methods),
			prototype = ModelExt.fn,
			scheme = (prototype.scheme = {}),
			nested = (prototype.nested = {}),
			defaults = prototype.defaults,
			required = prototype.required,
			getters = prototype.getters;

		// Коллекция
		if (methods.List) {
			ModelExt.List = methods.List;
			ModelExt.List.prototype.Model = ModelExt;
		} else {
			ModelExt.List = ModelExt.List.extend({Model: ModelExt});
		}

		// Глобальная коллекция в рамках модели
		ModelExt.all = new (ModelExt.List);
		ModelExt.all.local = true;

		// Генерируем схему
		/* istanbul ignore else */
		if (defaults) {
			(function _walker(attrs, prefix) {
				var keys = Object.keys(attrs);

				if (keys.length) {
					prefix = prefix ? prefix + '.' : '';

					keys.forEach(function (key) {
						var value = attrs[key];

						key = prefix + key;

						if (value instanceof Object) {
							if (value instanceof Model) {
								nested[key] = value.constructor;
								scheme[key] = 'model';
							}
							else if (value instanceof List) {
								nested[key] = value.constructor;
								scheme[key] = 'model.list';
							}
							else if (value instanceof Array) {
								scheme[key] = 'array';
							} else {
								scheme[key] = 'set';
								_walker(value, key);
							}
						}
						else {
							scheme[key] = _type(value);
						}
					});
				}
				else {
					scheme[prefix] = _type(attrs);
				}
			})(defaults);
		}

		// Генерируем метод установки обязательных параметров
		/* istanbul ignore else */
		if (required.length) {
			/* jshint evil:true */
			prototype._setRequired = Function('_clone', 'return function _setRequired(attrs) {\n' + required.map(function (name) {
				return name.split('.').reduce(function (prev, part, idx, parts) {
					var chain = parts.slice(0, idx + 1).join('.');
					return [
						prev,
						'if (attrs.' + chain + ' === void 0)',
						'  attrs.' + chain + ' = ' + (chain === name ? '_clone(this.defaults.' + chain + ')' : '{}')
					].join('\n');
				}, '');
			}).join('\n') + '\n}')(_clone);
		}

		// Генерируем активатор вложенных моделей
		var _nestedKeys = Object.keys(nested);

		if (_nestedKeys.length) {
			var _activateCode = [];
			var _deactivateCode = [];

			_nestedKeys.forEach(function (absKey) {
				var attr = 'attrs["' + absKey.replace(/\./g, '"]["') + '"]';
				var events = (scheme[absKey] === 'model' ? 'change' : 'update') + ' add remove destroy reset';

				_activateCode.push(
					'var _this = this;',
					'var Class = this.nested["' + absKey + '"];',
					'var isList = this.scheme["' + absKey + '"] == "model.list";',
					'var callback = this["_nested:' + absKey + '"] = function (evt) {',
					'  _this._nestedHandleEvent("' + absKey + '", evt);',
					'};',
					attr + ' = (Class.map ? Class.map(' + attr + ') : new Class(' + attr + ')).on("' + events + '", callback);'
				);

				_deactivateCode.push(
					attr + '.off("' + events + '", this["_nested:' + absKey + '"]);'
				);
			}, this);

			/* jshint evil:true */
			prototype._activateNested = Function('attrs', _activateCode.join('\n'));
			prototype._deactivateNested = Function('attrs', _deactivateCode.join('\n'));
		} else {
			prototype._activateNested = void 0;
			prototype._deactivateNested = void 0;
		}

		// Генерируем геттеры
		if (getters) {
			if (getters === true) {
				getters = {};

				Object.keys(defaults).forEach(function (attr) {
					getters[attr] = null;
				});
			}

			// Генерируем метод обновления геттеров
			/* jshint evil:true */
			prototype._updateGetters = Function(Object.keys(getters).map(function (name, getter) {
				getter = getters[name];

				/* istanbul ignore else */
				if (prototype.hasOwnProperty(name)) {
					throw "Unable to create a getter `" + name + "`, this key is already in use";
				}
				else if (typeof getter === 'function') {
					prototype['__getter__' + name] = getter;
					getter = 'this.__getter__' + name + '()';
				}
				else if (typeof prototype[getter] === 'function') {
					getter = 'this.' + getter + '()';
				}
				else if (getter === null || typeof getter === 'string') {
					getter = 'this.get(' + _stringifyJSON(getter || name) + ')';
				}

				return 'this.' + name + ' = ' + getter;
			}).join('\n'));
		}

		return	ModelExt;
	};


	/**
	 * Класс коллекции
	 * @static
	 * @memberOf Model
	 * @type {Model.List}
	 */
	Model.List = List;
	Model.List.fn.Model = Model; // Спорно, знаю.


	/**
	 * Глобальная коллекция для модели
	 * @static
	 * @memberOf Model
	 * @type {Model.List}
	 */
	Model.all = new List;
	Model.all.local = true;


	/**
	 * Установить модели в глобальной колеккции
	 * @memberOf Model
	 * @param   {Model[]}   models
	 * @param   {Object}    options
	 * @returns {*}
	 */
	Model.set = function (models, options) {
		return this.all.set(models, options);
	};


	/**
	 * Получить модель из глобальной коллекции
	 * @memberOf Model
	 * @param   {string|number}  id
	 * @returns {Model|undefined}
	 */
	Model.get = function (id) {
		return this.all.get(id);
	};


	/**
	 * Получить модель из глобальной коллекции даже если её нет
	 * @memberOf Model
	 * @param   {string|number}  id
	 * @returns {Model}
	 */
	Model.getSafe = function (id) {
		return this.all.getSafe(id);
	};


	/**
	 * Создание mock для модели
	 * @memberOf Model
	 * @param  {Object}  mocks
	 */
	Model.mock = function (mocks) {
		for (var method in mocks) {
			var url,
				variants = [].concat(mocks[method]),
				i = 0,
				n = variants.length,
				query
			;

			for (; i < n; i++) {
				url = this.url(method, variants[i].query || {});
				query = method == 'add' ? new this(variants[i].query).toJSON() : variants[i].query;

				this.fn.request.mock({
					url: url,
					once: variants[i].once,
					type: /^find/.test(method) ? 'GET' : (/remove/.test(method) && !this.fn.request.setup('emulateHTTP') ? 'DELETE' : 'POST'),
					data: /^(add|save|remove)$/.test(method) ? this.fn.prepareSendData(method, query) : query,
					status: variants[i].status,
					body: variants[i].body,
					responseText: variants[i].result
				});
			}
		}
	};


	/**
	 * Сформировать URL
	 * @memberOf Model
	 * @param   {string}  name
	 * @param   {Object}  [params]
	 * @returns {string}
	 */
	Model.url = function (name, params) {
		var url = this.fn[name + 'Url'] || this.fn.url;

		/* istanbul ignore else */
		if (typeof url === 'function') {
			url = url(params);
		}
		
		return String(url).replace(/:([a-z_]+)/g, function (_, name) {
			return params[name] || '';
		}).replace(/([^$\/])\/+/g, '$1/');
	};


	/**
	 * Получить данные от сервера, либо из кеша
	 * @memberOf Model
	 * @param   {Object}   query
	 * @param   {boolean}  [single]
	 * @param   {boolean}  [force]
	 * @returns {Promise}
	 */
	Model.fetchData = function (query, single, force) {
		var meta = logger.meta(-2),
			XModel = this,
			storage = XModel.fn.storage,
			method = single ? 'findOne' : 'find',
			promise,

			findReq = function () {
				// Формируем url
				var url = XModel.url(method, query);

				// В стородже ничего, выполняем запрос
				return XModel.fn.request.get(
					url,
					query,
					{
						logger: XModel.fn.className + '.' + method,
						loggerMeta: meta,
						dataType: 'json'
					}).then(function (req) {
						// Данные получены, сохраняем в хранилище
						var body = XModel.fn.parse(req.body, req);
						storage && storage.save(method, query, body);
						return body;
					});
			}
		;

		query = query || {};

		if (storage && !force) {
			// Пробуем получить данные из хранилища
			promise = logger.wrap('[[' + XModel.fn.className + '.storage.' + method + ']]', query, storage[method](query))['catch'](findReq);
		} else {
			promise = findReq();
		}

		/* jshint expr:true */
		promise.__logger__ && (promise.__logger__.meta = meta);
		promise.__noLog = true;

		return promise;
	};


	/**
	 * Получить коллекцию
	 * @memberOf Model
	 * @param   {Object}   [query]   запрос
	 * @param   {Object}   [options] опции
	 * @returns {ModelListPromise}
	 */
	Model.find = function find(query, options) {
		return (new this.List).fetch(query, options);
	};


	/**
	 * Получить модель
	 * @memberOf Model
	 * @param   {Object|string}   query   запрос или id
	 * @returns {Promise}
	 */
	Model.findOne = function findOne(query) {
		var XModel = this,
			idAttr = XModel.fn.idAttr,
			hasOne = !!(XModel.fn.findOneUrl || XModel.fn.url),
			model,
			id,
			promise,
			queryKey
		;

		/* jshint eqnull:true */
		if ((query != null) && !(query instanceof Object)) {
			id = query;
			(query = {})[idAttr] = id;
		} else {
			query = query || /* istanbul ignore next */ {};
		}

		// Пробуем получить модель из глобальной коллекции или зарезервировать его в длкальном хранилиже.
		id = query[idAttr];
		queryKey = _stringifyJSON(query);
		model = XModel.all.get(id);

		if (model && !model.expired && model.isDataFully(query)) {
			promise = Promise.resolve(model);
		}
		else {
			// Если нет `findOneUrl` то делаем запрос без параметров,
			// после чего из коллекции получем модель
			promise = this.fetchData(hasOne ? query : {}, hasOne)
				.then(function (attrs) {
					var err;

					if (!hasOne || id == null) {
						attrs = (id == null)
									? ((attrs instanceof Array) ? attrs[0] : attrs)
									: attrs.filter(function (attrs) { return attrs[idAttr] == id; })[0]
						;
					}

					if (attrs) {
						// Получаем "safe" модель
						model = XModel.all.getSafe(attrs[idAttr]);

						model.expired = false;
						model.set(attrs, {clean: true, query: query, sync: true});

						XModel.all.set([model]);

						return model;
					}
					else {
						return Promise.reject(new Error('MODEL_NOT_FOUND'));
					}
				})
			;
		}

		return promise;
	};


	/**
	 * Создать и сохранить модель
	 * @param   {Object}  attrs
	 * @returns {Promise}
	 */
	Model.save = function (attrs) {
		var model = new this(attrs);
		return model.save();
	};


	/**
	 * Мапинг данных в модель или коллекцию
	 * @memberOf Model
	 * @param   {Object|Object[]} data
	 * @returns {Model|Model.List}
	 */
	Model.map = function (data) {
		var result = this.all.set([].concat(data), {clone: true});
		return (data instanceof Array) ? result : result[0];
	};


	/**
	 * Наблюдать за изменениями модели (только для браузеров с поддердкой Object.observe)
	 * @param {string} level  уровень: `log`, `info`, `warn` или `error`
	 * @param {Model|Model.List|Array|function} target  цель наблюдения, если передана функция, то следим за `all`
	 * @param {function} [callback]   Функция, вызываемая при возникновении изменений в объекте
	 */
	/* istanbul ignore next */
	Model.observe = function (level, target, callback) {
		if (!callback) {
			if (target instanceof Function) {
				callback = target;
			}

			target = this.all;
		}

		if (!(target instanceof Array || target instanceof List)) {
			target = [target];
		}

		level = level || 'log';

		var observer = function (chain, changes) {
			changes.forEach(function (change) {
				var attr = change.name,
					newValue = chain === '' ?
								this[attr] :
								this.get((chain.indexOf('.') > 0 ? chain.substr(chain.indexOf('.') + 1) + '.' : '') + attr);

				console[level](this.className +
					'(' + this.id + ')' +
					(chain ? '.' + chain : '') +
					'.{' + attr + '} is ' +
					(change.type === 'add' ? 'added' : 'updated') +
					': {' + change.oldValue + '} → {' + newValue + '}'
				);
			}, this);

			/* jshint expr:true */
			callback && callback(this, level, type, changes);

			if (level === 'error') {
				/* jshint -W087 */
				debugger;
			}
		};

		target.forEach(function (model) {
			Object.observe(model, observer.bind(model, ''));

			(function _next(chain, attrs) {
				if (attrs instanceof Object && !attrs.set) {
					Object.observe(attrs, observer.bind(model, chain.join('.')));

					Object.keys(attrs).forEach(function (key) {
						_next(chain.concat(key), attrs[key]);
					});
				}
			})(['attributes'], model.attributes);
		});
	};


	// Подмешиваем Emitter
	Emitter.apply(Model.fn);


	// Export
	Model.version = '0.13.1';
	return Model;
});
